<template>
  <v-container fluid class="pt-3">
    <GPTable :shop="shop" :gp="true" :showStat="true"></GPTable>
  </v-container>
</template>
<script>
import GPTable from "@/components/table/GPTable";

export default {
  components: {
    GPTable,
  },
  data() {
    return {
      shop: null,
    };
  },
  created() {},
};
</script>
